<div class="bulk-import-result">
    <div class="bulk-import-result-header">
        <h4>Import Results</h4>
        <button
                type="button"
                class="btn-action"
                *ngIf="failedRowsCsvBase64"
                (click)="downloadFailureReport()">
            <fa-icon [icon]="['fas', 'download']"></fa-icon>
            {{ downloadButtonLabel }}
        </button>
    </div>

    <div class="bulk-import-result-summary">
        <p><strong>Total Imported:</strong> {{ totalImported }}</p>
        <p><strong>Total Failed:</strong> {{ totalFailed }}</p>
    </div>

    <div class="responsive-table-wrapper" *ngIf="errors.length">
        <table>
            <thead>
            <tr>
                <th>Row</th>
                <th>Vehicle Number</th>
                <th>Field</th>
                <th>Message</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let error of errors">
                <td>{{ error.row }}</td>
                <td>{{ error.vehicleNumber || '-' }}</td>
                <td>{{ error.field || '-' }}</td>
                <td>{{ error.message }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
